import clsx from 'clsx';
import React from 'react';

import { Icon } from '../Icon/Icon';

import styles from './Tag.module.scss';

interface TagProps {
  label: string;
  onRemove?: (label: string) => void;
  className?: string;
  color?: 'gray' | 'red';
}

export const Tag: React.FC<TagProps> = ({ label, onRemove, className, color = 'gray' }) => (
  <div
    className={clsx(styles.tag, className, {
      [styles.static]: !onRemove,
      [styles[`static-${color}`]]: !onRemove,
    })}
  >
    <span>{label}</span>
    {onRemove && (
      <Icon
        onClick={onRemove.bind(null, label)}
        name="xicon"
      />
    )}
  </div>
);
